<template>
  <ChartLayout :title="title" palette="light-highlight">
    <Chart :options="chartOptions" />
  </ChartLayout>
</template>

<script>
import { Chart } from "highcharts-vue";
import ChartOptions, {
  ChartLayout,
} from "@international-energy-agency/vue-ui/highcharts";
export default {
  props: {
    /*
     * Expects { name, series: [] }
     */
    sets: {
      type: Array,
      required: true,
    },
    /**
     * { id, name, value } where id corresponds to the series included in each set
     */
    data: {
      type: Array,
      required: true,
    },
    /*
     * Key to use for determining the set
     */
    setKey: {
      type: String,
      default: "id",
    },
    /*
     * Name for the whole set
     */
    name: {
      type: String,
      required: true,
    },
    /**
     * Title of the chart
     */
    title: {
      type: String,
      required: true,
    },
    /** Series to highlight */
    highlight: {
      type: Array,
      default: null,
    },
  },
  components: {
    Chart,
    ChartLayout,
  },
  computed: {
    chartData() {
      const { data, sets, setKey, highlight } = this;
      return data.reduce((data, row) => {
        const matchingSets = sets.filter((set) => set.series === row[setKey]);
        if (!matchingSets) return data;
        return [
          ...data,
          ...matchingSets.map((set) => ({
            //...set,
            dataLabels: set.dataLabels,
            name: set.name,
            sets: set.sets,
            value: row.value,
            colorIndex: row.colorIndex || 0,
            className:
              !highlight || !highlight.includes(row[setKey])
                ? "transparent"
                : "",
          })),
        ];
      }, []);
    },
    chartOptions() {
      return ChartOptions.buildOptions(
        {
          tooltip: {
            valueDecimals: 0,
          },
          series: [
            {
              name: this.name,
              data: this.chartData,
            },
          ],
        },
        "venn"
      );
    },
  },
};
</script>

<style>
.highcharts-venn-series .highcharts-point.transparent {
  fill-opacity: 0;
}
.highcharts-venn-series .highcharts-point {
  fill-opacity: 0.25;
}
</style>
